import { CommonModule, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ActivatedRoute } from '@angular/router';
import { FuseCardComponent } from '@fuse/components/card';
import { iTerms } from 'app/core/shared-services/interfaces.types';
import { ILead, IResponse } from 'app/core/shared-services/shared-interface.types';
import { SharedMethodsModule } from 'app/core/shared-services/shared-methods.module';
import { WebStorage } from 'app/core/shared-services/web.storage';
import { timer } from 'rxjs';

@Component({
  selector: 'app-terms',
  standalone: true,
  imports: [NgIf, CommonModule, MatCheckboxModule, FuseCardComponent],
  templateUrl: './terms.component.html',
  styleUrl: './terms.component.scss'
})
export class TermsComponent {
  public disableButton: boolean;
  @Output() public termsAndConditions: EventEmitter<Array<any>> = new EventEmitter();
  public lead: ILead;
  public packageEntityID: number;
  public termsList: Array<any> = [];
  public termsFound: boolean;

  constructor(
    private _sharedMethods: SharedMethodsModule,
    private _webStorage: WebStorage,
    private activatedRouter: ActivatedRoute
  ) {

  }

  async ngOnInit() {
    timer(4000).subscribe(() => {
      this.initComponent();
    });
  }


  private async initComponent() {
    if (localStorage.getItem('preorderPackageEntityId')) {
      const rawPackageEntityID = localStorage.getItem('preorderPackageEntityId');
      this.packageEntityID = rawPackageEntityID ? JSON.parse(rawPackageEntityID) : null;
    }
    try {
      const termsAndConditionsResult: any = await this._sharedMethods.getTermsAndConditions(this._webStorage.CartInfo.getValue().PackageEntityID ?? this.packageEntityID);
      const globalTermsAndConditionsResult: any = await this._sharedMethods.getGlobalTermsAndConditions();
      const list = [...termsAndConditionsResult.result, ...globalTermsAndConditionsResult.result];
      this.termsList = [...termsAndConditionsResult.result, ...globalTermsAndConditionsResult.result].filter((value, index, self) =>
        index === self.findIndex((term) => term.TermsAndConditionsTemplateID === value.TermsAndConditionsTemplateID)
      );

      if(this.termsList.length == 0) {
        this.termsFound = false
      } else {
        this.termsFound = true
      }

      this.termsAndConditions.emit(this.termsList);
    } catch (error) {
    }
  }

  public toggleMat(event: any, terms: any) {
    terms.isAccepted = event.checked;
    this.termsList.forEach(element => {
      if (element.TermsAndConditionsTemplateID === terms.TermsAndConditionsTemplateID) {
        element.isAccepted = event.checked;
      }
    });

    this.termsAndConditions.emit(this.termsList);
  }
}
